// extracted by mini-css-extract-plugin
module.exports = {"introContainer":"intro_introContainer__lI2Bw","introTitle":"intro_introTitle__JccQj"};